module.exports = __webpack_public_path__ + "media/vuesrc/apps/public/images/investments/hero-desktop-fr-40ce48fd5da61a0aefef656694eb82fe.png";